import React from 'react'
import HairTrends from "./../../../../../Images/Blog/2025HairTrends/Banner.png";

const TrendyHairHighlightImg = () => {
  return (
    <div className="blogImg-content">
      <img src={HairTrends} alt="HairTrends" loading="lazy" />
    </div>
  )
}

export default TrendyHairHighlightImg
